export default "__VITE_ASSET__CXDH0vDT__"